<div
  data-cy="expire-date"
  class="component-container"
  [style]="{
    color: config().color,
    fontFamily: config().fontFamily,
    backgroundColor: config().backgroundColor,
  }"
>
  <p
    class="label"
    [style.backgroundColor]="config().labelBackgroundColor"
    [innerHTML]="
      config().template
        | replaceVars
          : (campaignStartDate() | date: 'd MMMM')!
          : false
          : '{startDate}'
        | replaceVars
          : (campaignEndDate() | date: 'd MMMM')!
          : false
          : '{endDate}'
        | safe
    "
  ></p>
</div>
